import FieldsInput from "../../../../components/FieldComponents/FieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../../Client/ClientManagement/AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { EMAIL_VALIDATION_PATTERN } from "../../../../utils/constants";

const SystemUserEmailAddress = (props) => {
  const { systemUserEmail } = props;
  const style = Style();
  const { t } = useTranslation();
  return (
    <>
      <Stack className={style.client_field}>
        <FieldsInput
          label={t("email_address")}
          validationMessage={props.errors?.systemUserEmail?.message}
          id="systemUserEmail"
          placeholder={t("enter_email_address")}
          name="systemUserEmail"
          inputDefaultValue={systemUserEmail}
          inputClassName={mergeClasses(style.textboxInput)}
          validation={props.register("systemUserEmail", {
            required: `${t("validation_message.email_address_is_required")}`,
            pattern: {
              value: EMAIL_VALIDATION_PATTERN,
              message: "entered value does not match email format",
            },
          })}
        />
      </Stack>
    </>
  );
};

export default SystemUserEmailAddress;
